import { DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import useDevMode from 'common/hooks/useDevMode';
import { FEATURE_SLOTS } from 'modules/insights/constants/constants-development';

function ApiDropdown() {
  const devMode = useDevMode();
  const featureSlot = sessionStorage.getItem('featureSlot') ?? 'Dev';

  const selectFeatureSlot = (event: DropDownButtonItemClickEvent) => {
    sessionStorage.setItem('featureSlot', event.item);
    window.location.reload();
  };

  if (!devMode) {
    return null;
  }

  return (
    <DropDownButton
      size="small"
      text={`API Feature (${featureSlot})`}
      items={FEATURE_SLOTS}
      onItemClick={selectFeatureSlot}
    />
  );
}

export default ApiDropdown;
